const HeaderTop = () => {
  return (
    <div className="header_top">
      <div className="container">
        <div className="header_top_inner d-flex">
          <p>FREE SHIPPING ON ALL ORDERS OVER $75! START SHOPPING TODAY</p>
          <a href="/" onClick={(e) => e.preventDefault()} className="gift_top">
            <i className="fas fa-gift" />
            {/*<img src={require('assets/images/gift_icon.png').default} class="img-responsive">*/}
            gift cards
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;
